import { apiFetch } from "#lib/api";
import { IFanCard } from "#entities/files";

export async function fetchFanboxProfileFancards(profileID: string) {
  const path = `/fanbox/user/${profileID}/fancards`;
  const cards = await apiFetch<IFanCard[]>(path, { method: "GET" });

  return cards;
}
